import React, { useState } from 'react';
import { HRCommandCenter } from './pages/HRCommandCenter';
import { CompanyResources } from './pages/CompanyResources';
import { EmployeePortal } from './pages/EmployeePortal';
import { Recruiting } from './pages/Recruiting';
import { Navbar } from './components/Navbar';
function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'resources' | 'recruiting'>('home');
  const [viewMode, setViewMode] = useState<'admin' | 'employee'>('admin');
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <Navbar currentPage={currentPage} onNavigate={setCurrentPage} viewMode={viewMode} onViewModeChange={setViewMode} data-id="element-1" />
      <main data-id="element-2">
        {viewMode === 'admin' ? currentPage === 'home' ? <HRCommandCenter data-id="element-3" /> : currentPage === 'recruiting' ? <Recruiting data-id="element-4" /> : <CompanyResources data-id="element-5" /> : <EmployeePortal data-id="element-6" />}
      </main>
    </div>;
}
export { App };